(function() {
'use strict';

angular
    .module('TR')
    .service('shortlistService', shortlistService);

function shortlistService($http, $q, arrayUtil, hotelRehydrator, $rootScope, broker) {
    const url = '/api2/hotelshortlist/';
    let shortlists;

    $rootScope.$on('auth:signout', _clearCache);
    $rootScope.$on('auth:signin', _clearCache);

    const service = {
        clear,
        getHotelsInShortlist,
        getShortlist,
        getShortlistEstabIds,
        removeFromShortlist,
        addToShortlist,
        isHotelShortlisted,
        getUrl,
        toggleHotel
    };

    function _getShortlists() {
        if (!shortlists) {
            shortlists = $http.get(`${url}getall`, { ignoreErrors: true })
                .then(function(result) {
                    return result.data.Shortlists;
                });
        }
        return shortlists;
    }

    function _clearCache() {
        shortlists = null;
    }

    function clear(id) {
        return $http.post(`${url}clear`, id)
            .then(function() {
                shortlists = null;
            });
    }

    function getHotelsInShortlist() {
        return getShortlist()
            .then(function(sl) {
                if (!sl) { return null; }
                const estabIds = [];
                angular.forEach(sl.Hotels, function(h) {
                    estabIds.push(h.EstabId);
                });

                return hotelRehydrator.hotels(estabIds)
                    .then(function(hotels) {
                        return {
                            ShortlistId: sl.ShortlistId,
                            Hotels: hotels
                        };
                    });
            });
    }

    function getShortlist() {
        return _getShortlists()
            .then(function(sls) {
                return sls[0];
            });
    }

    function getShortlistEstabIds() {
        return getShortlist().then(function(sl) {
            if (!sl) { return []; }
            return arrayUtil.map(sl.Hotels, function(h) {
                return h.EstabId;
            });
        });
    }

    function toggleHotel(hotel) {
        return isHotelShortlisted(hotel).then(function(isShortlisted) {
            const p = isShortlisted ? removeFromShortlist(hotel) : addToShortlist(hotel);
            return p.then(function() {
                return !isShortlisted;  //it worked so invert setting
            }, function() {
                return isShortlisted;   //it didn't so leave it alone
            });
        });
    }

    function removeFromShortlist(hotel) {
        if (_.get(hotel, 'Id', 0) <= 0) {
            return $q.when().then(gatherShortlist);
        }
        return $http.post(`${url}removehotel`, {
            EstabId: hotel.Id
        }).then(gatherShortlist);

        function gatherShortlist() {
            return _getShortlists()
                .then(function(sls) {
                    angular.forEach(sls, function(sl) {
                        const index = arrayUtil.indexOf(sl.Hotels, function(h) {
                            return h.EstabId === hotel.Id;
                        });
                        if (index >= 0) {
                            sl.Hotels.splice(index, 1);
                            broker.publish('hotelRemovedFromShortlist', hotel);
                        }
                    });
                });
        }
    }

    function addToShortlist(hotel) {
        function add(sl) {
            return $http.post(`${url}addhotel`, {
                EstabId: hotel.Id,
                ShortlistId: sl.ShortlistId,
                Note: ''
            }).then(function(result) {
                sl.Hotels.push({ EstabId: hotel.Id });
                broker.publish('hotelAddedToShortlist', hotel);
                return result.data;
            });
        }

        return _getShortlists()
            .then(function(sls) {
                return add(sls[0]);
            });
    }

    function isHotelShortlisted(hotel) {
        return _getShortlists()
            .then(function(sls) {
                let found = false;
                angular.forEach(sls, function(sl) {
                    angular.forEach(sl.Hotels, function(h) {
                        if (h.EstabId === hotel.Id) {
                            found = true;
                        }
                    });
                });
                return found;
            });
    }

    function getUrl() {
        return url;
    }

    return service;
}
})();
